import { DropdownButton } from '@dixa/lib-shared-habla';
import { Cell } from '@tanstack/react-table';
import ArticleMenu from 'collection/pages/collectionEdit/components/articleMenu/articleMenu';
import { ArticleListItemResultFragment } from 'lib-knowledge-management-common/graphql';

type ActionColumnHeaderContext = {
  cell: Cell<ArticleListItemResultFragment, string>;
};
export function getCollectionSearchActionColumn(): {
  cell: (info: ActionColumnHeaderContext) => JSX.Element;
} {
  return {
    cell: (info: ActionColumnHeaderContext): JSX.Element => {
      return (
        <DropdownButton
          icon="dots-h"
          buttonProps={{ variant: 'tertiary' }}
          dropdown={
            <ArticleMenu
              articleId={info.cell.row.original.id}
              isSyncedWithElevio={info.cell.row.original.isSyncedWithElevio}
            />
          }
        />
      );
    },
  };
}
